// extracted by mini-css-extract-plugin
export default {"wrapper":"home_wrapper__yyS7l","body":"home_body__i1OE-","statistic":"home_statistic__DLGGa","title":"home_title__9Yaqq"};